import { chakra } from '@chakra-ui/react'
import { Button } from '@verbit-ai/verbit-ui-library'

import { shouldForwardProp } from 'src/utils/should-forward-prop'

import { QUICK_ACTION_MENU_HEIGHT } from './constants'

const ELEMENTS_GAP = 8

type ContainerProps = {
    $x: number
    $y: number
}
export const Container = chakra<'div', ContainerProps>('div', {
    baseStyle: ({ $x, $y, theme }) => ({
        display: 'inline-flex',
        flexShrink: 0,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme.palette.quickActionMenu.backgroundColor,
        borderRadius: '6px',
        padding: '8px 4px',
        gap: `${ELEMENTS_GAP * 2}px`,
        height: `${QUICK_ACTION_MENU_HEIGHT}px`,
        position: 'absolute',
        left: `${$x}px`,
        top: `${$y}px`,
        transform: 'translateX(-50%)',
        // dividers
        '& > *:not(:last-child)': {
            position: 'relative',
            _after: {
                display: 'block',
                content: '""',
                width: '1px',
                height: '28px',
                background: theme.palette.quickActionMenu.dividerColor,
                position: 'absolute',
                top: '2px',
                bottom: '2px',
                right: `-${ELEMENTS_GAP}px`,
            },
        },
    }),
    shouldForwardProp,
})

export const BasicButton = chakra(Button, {
    baseStyle: ({ theme }) => ({
        height: '32px',
        cursor: 'pointer',
        color: theme.palette.quickActionMenu.buttonColor,
        _hover: {
            color: theme.palette.quickActionMenu.buttonColor,
            backgroundColor: theme.palette.quickActionMenu.buttonHoverBgColor,
        },
        _disabled: {
            color: theme.palette.quickActionMenu.buttonDisabledColor,
            cursor: 'not-allowed',
            _hover: {
                color: theme.palette.quickActionMenu.buttonDisabledColor,
                backgroundColor: 'transparent',
            },
        },
    }),
})
